export default __webpack_public_path__ + "static/media/SourceSansPro-Italic.f102be58.ttf";